<template>
  <div>
    <Nav />
    <Banner :title="title" />

    <div class="posts businesses">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="position-relative">
              <input
                type="text"
                class="search-item"
                :placeholder="'Search ' + title"
                v-model="query"
              />
              <i class="fas fa-search position-absolute search-icon"></i>
            </p>
          </div>
        </div>
        <div class="row" v-if="title.indexOf('events') > -1">
          <div class="col-12">
            <v-calendar is-expanded />
          </div>
        </div>
        <div class="row">
          <div
            :key="title + '-' + index"
            v-for="(item, index) in relatedItems"
            class="col-sm-12 col-md-4 col-lg-4"
          >
            <div class="card my-3">
              <div class="card-body">
                <p class="card-content">
                  <strong>{{ item.company_name | niceTitle }}</strong>
                </p>
                <p class="card-content">
                  <template v-if="item.phone">
                    <span class="d-block">
                      <i class="fas fa-phone-alt mr-2"></i>
                      <a
                        :href="'tel:' + item.phone"
                        :title="'Call ' + item.company_name"
                        >{{ item.phone | nicePhoneNumber }}</a
                      >
                    </span>
                  </template>
                  <template v-if="item.email">
                    <span class="d-block">
                      <i class="fas fa-envelope mr-2"></i>
                      <a
                        :href="'mailto:' + item.email"
                        :title="'Email ' + item.company_name"
                        >{{ item.email }}</a
                      >
                    </span>
                  </template>
                  <template v-if="item.address">
                    <span class="d-block">
                      <i class="fas fa-map-marker mr-2"></i>{{ item.address }}
                    </span>
                  </template>
                  <template v-if="item.website">
                    <span class="d-block">
                      <i class="fas fa-link mr-2"></i>
                      <a
                        :href="item.website"
                        target="_blank"
                        :title="'Visit ' + item.company_name + '\'s website'"
                        >Visit Site</a
                      >
                    </span>
                  </template>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/Banner";
import axios from "axios";
import moment from "moment";


export default {
  name: "Business",
  components: {
    Banner: Banner
  },
  props: {
    title: {
      type: String,
      default: () => ""
    }
  },
  data: () => ({
    items: [],
    relatedItems: [],
    query: "",
    selectedPost: false
  }),
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      axios
        .get(process.env.VUE_APP_SERVER + this.title)
        .then(res => {
          if (res.data) {
            this.items = res.data.result.reverse();
            this.relatedItems = res.data.result.reverse();
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    showRelatedItems() {
      this.relatedItems = this.items.filter(i => {
        if (
          (i.company_name &&
            i.company_name.toLowerCase().indexOf(this.query) > -1) ||
          (i.address && i.address.toLowerCase().indexOf(this.query) > -1) ||
          (i.phone && i.phone.toLowerCase().indexOf(this.query) > -1)
        ) {
          return i;
        }
      });
    },
    placeholderImage() {
      let eIndex = Math.floor(Math.random() * this.placeholderImages.length);
      if (eIndex > this.placeholderImages.length - 1) eIndex -= 1;
      const image = this.placeholderImages[eIndex];
      return image;
    }
  },
  filters: {
    niceDate(value) {
      return "Published " + moment.utc(value).format("MMM Do YYYY");
    },
    niceTitle(value) {
      if (value.indexOf(" ") > -1) {
        return value
          .split(" ")
          .map(w => {
            return w[0].toUpperCase() + w.substring(1);
          })
          .join(" ");
      } else {
        return value[0].toUpperCase() + value.substring(1);
      }
    },
    nicePhoneNumber(value) {
      const short = `(306) ${value.substring(0, 3)} ${value.substring(3)}`;
      const full = `(${value.substring(0, 3)}) ${value.substring(
        3,
        6
      )} ${value.substring(6)}`;
      return value.length === 10 ? full : short;
    }
  },
  watch: {
    query() {
      if (this.query.length > 2) {
        this.showRelatedItems();
      } else {
        this.relatedItems = this.items;
      }
    }
  }
};
</script>

<style lang="scss">
.search-item {
  border: solid 1px #ccc;
  border-radius: 20px;
  padding: 0.45rem;
  padding-left: 1rem;
  &:focus {
    outline: none;
  }
}

.search-icon {
  top: 12px;
  left: 168px;
  color: #ccc;
}

.posts {
  padding: 3rem 0;

  .post-image {
    margin: 0 0 1rem;
    max-height: 165px;
    overflow: hidden;

    margin-bottom: 1rem;

    img {
      position: relative;
      width: 110%;
      left: -5%;
      top: -5%;
    }
  }
}

.post-hero {
  background-size: 100%;
  background-position: 50%;
  min-height: 200px;
  h3 {
    padding-top: 4rem;
  }
  h4 {
    padding-bottom: 3rem;
  }
  h3,
  h4 {
    text-shadow: 0 0 5px #000;
    color: #fff;
  }
}

.post-content {
  min-height: 70vh;
  .col {
    min-height: 100%;
  }
}

.back-btn {
  text-align: right;
}
</style>
